import React from 'react';

import What from './what';

export default React.memo(What);
